import { render, staticRenderFns } from "./SubmitDeposit.vue?vue&type=template&id=4f0c7572&scoped=true"
import script from "./SubmitDeposit.vue?vue&type=script&lang=js"
export * from "./SubmitDeposit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f0c7572",
  null
  
)

export default component.exports